import axios from 'axios'
import { showError } from './notificationService'
import i18n from '../i18n/config'
import { getLocalizedApiErrorMessage } from '../utils/apiErrorI18n'

const getLocalizedBackendMessage = (error: unknown): string | null => {
    const fallback = '__UNMAPPED_API_ERROR__'
    const message = getLocalizedApiErrorMessage(
        error,
        fallback,
        i18n.t.bind(i18n)
    )
    return message === fallback ? null : message
}

export const handleApiError = (
    error: unknown,
    defaultMessage: string
): void => {
    if (axios.isAxiosError(error)) {
        const response = error.response
        if (response?.data?.message) {
            showError(response.data.message)
        } else if (response?.status === 401) {
            showError(
                i18n.t('errors:auth.sessionExpired', {
                    defaultValue: '登录已过期，请重新登录',
                })
            )
        } else if (response?.status === 403) {
            const localizedMessage = getLocalizedBackendMessage(error)
            if (localizedMessage) {
                showError(localizedMessage)
                return
            }
            showError(
                i18n.t('errors:network.forbidden', {
                    defaultValue: '您没有权限执行此操作',
                })
            )
        } else if (response?.status === 404) {
            showError(
                i18n.t('errors:network.notFound', {
                    defaultValue: '请求的资源不存在',
                })
            )
        } else if (response?.status === 500) {
            showError(
                i18n.t('errors:network.serverError', {
                    defaultValue: '服务器错误，请稍后再试',
                })
            )
        } else {
            showError(
                getLocalizedApiErrorMessage(
                    error,
                    defaultMessage,
                    i18n.t.bind(i18n)
                )
            )
        }
    } else if (error instanceof Error && !/[A-Za-z]/.test(error.message)) {
        showError(error.message || defaultMessage)
    } else {
        showError(defaultMessage)
    }
}

export const getFriendlyErrorMessage = (error: unknown): string => {
    if (axios.isAxiosError(error)) {
        const status = error.response?.status

        if (status === 401) {
            return i18n.t('errors:auth.sessionExpired', {
                defaultValue: '登录已过期，请重新登录',
            })
        }
        if (status === 403) {
            const localizedMessage = getLocalizedBackendMessage(error)
            if (localizedMessage) {
                return localizedMessage
            }
            return i18n.t('errors:network.forbidden', {
                defaultValue: '您没有权限执行此操作',
            })
        }
        if (status === 404) {
            return i18n.t('errors:network.notFound', {
                defaultValue: '请求的资源不存在',
            })
        }
        if (status === 500) {
            return i18n.t('errors:network.serverError', {
                defaultValue: '服务器内部错误，请稍后再试',
            })
        }

        return getLocalizedApiErrorMessage(
            error,
            error.message ||
                i18n.t('errors:general.operationFailed', {
                    defaultValue: '请求失败',
                }),
            i18n.t.bind(i18n)
        )
    }

    if (error instanceof Error && !/[A-Za-z]/.test(error.message)) {
        return error.message
    }

    return i18n.t('errors:general.unknownError', {
        defaultValue: '发生未知错误',
    })
}
